import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash, faPlus } from "@fortawesome/free-solid-svg-icons";
import {
  Table,
  Button,
  Card,
  CardBody,
  CardTitle,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
} from "reactstrap";
import Moment from "react-moment";

import { default as EditUserProfileModal } from "../UserViewPage/components/modals/EditUserProfileModal";

class UserManagement extends Component {
  constructor(props) {
    super(props);
    this.showActions = props.showActions;
    this.state = {
      newUser: {
        _id: "newUser",
        local: { email: "" },
        personal: { name: "", phoneNumber: "", profilePictureUrl: "" },
        roles: "User",
        access: { level: "User" },
      },
      userToDelete: null,
      isDeleting: false,
      filterText: "",
    };
  }

  handleFilterChange = (e) => {
    this.setState({ filterText: e.target.value });
  };

  updateUsersList = (e) => {
    // re-fetch all users
    this.props.fetchAllUsers();
  };

  requestDelete = (user) => {
    this.setState({ userToDelete: user });
  };

  cancelDelete = () => {
    this.setState({ userToDelete: null });
  };

  confirmDelete = () => {
    const { userToDelete } = this.state;
    if (!userToDelete) return;
    this.setState({ isDeleting: true });
    this.props.deleteUser(userToDelete._id).then(() => {
      this.setState({ userToDelete: null, isDeleting: false });
    });
  };

  componentDidMount() {
    this.props.fetchAllUsers();
  }

  render() {
    const { users, isLoading, activateModal } = this.props;
    const filter = this.state.filterText.trim().toLowerCase();
    const filteredUsers = filter
      ? users.filter((user) => {
          const name = (user.personal && user.personal.name) || "";
          const role = (user.access && user.access.level) || "";
          return (
            name.toLowerCase().includes(filter) ||
            role.toLowerCase().includes(filter)
          );
        })
      : users;
    return (
      <Card className="mt-2">
        <CardBody>
          <CardTitle>
            {
             this.showActions &&
             (<div className="text-right mr-3 pt-2">
              <span>
                <FontAwesomeIcon
                  icon={faPlus}
                  onClick={() => activateModal("editUserProfileModal")}
                />
              </span>
            </div>)
            }
            <EditUserProfileModal user={this.state.newUser} setUser={this.updateUsersList} />
          </CardTitle>
          <div className="col-12">
            <Input
              type="text"
              className="mb-2"
              placeholder="Filter by name or role..."
              value={this.state.filterText}
              onChange={this.handleFilterChange}
            />
            {!isLoading && (
              <Table size="sm" hover>
                <tbody>
                  {filteredUsers.map((user) => (
                    <tr>
                      <td className="pt-2">{user.personal.name}</td>
                      <td className="text-center pt-2">
                        <Moment format="MM/DD/YYYY">{user.meta.created}</Moment>
                      </td>
                      <td className="text-center pt-2">{user.access.level}</td>
                      {
                        this.showActions && 
                        (<td className="text-right">
                          <Button className="mr-1" size="sm" color="warning">
                            <a href={"/user/view/" + user._id}>
                              <FontAwesomeIcon size="sm" icon={faEdit} />
                            </a>
                          </Button>
                          <Button
                            size="sm"
                            color="danger"
                            onClick={() => this.requestDelete(user)}
                          >
                            <FontAwesomeIcon size="sm" icon={faTrash} />
                          </Button>
                        </td>)
                      }
                    </tr>
                  ))}
                  {filteredUsers.length === 0 && (
                    <tr>
                      <td colSpan="4" className="text-center pt-2">
                        No users match "{this.state.filterText}".
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            )}
          </div>
        </CardBody>
        <Modal isOpen={!!this.state.userToDelete} toggle={this.cancelDelete}>
          <ModalHeader toggle={this.cancelDelete}>Delete User</ModalHeader>
          <ModalBody>
            {this.state.userToDelete && (
              <span>
                Are you sure you want to delete{" "}
                <strong>
                  {this.state.userToDelete.personal.name ||
                    this.state.userToDelete.local.email}
                </strong>
                ? This action cannot be undone.
              </span>
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.cancelDelete}>
              Cancel
            </Button>
            <Button
              color="danger"
              onClick={this.confirmDelete}
              disabled={this.state.isDeleting}
            >
              {this.state.isDeleting ? "Deleting..." : "Delete"}
            </Button>
          </ModalFooter>
        </Modal>
      </Card>
    );
  }
}

export default UserManagement;
